export default __webpack_public_path__ + "static/media/1-5-3.6654885e.jpg";